export enum AnalyticsEvents {
  ConnectVisit = 'Connect Visit',
  ConnectSignUp = 'Connect Sign Up',
  SignUpFail = 'Sign Up Fail',
  Login = 'Login',
  LoginSSO = 'Login SSO',
  LoginFail = 'Login Fail',
  Logout = 'Logout',
  LocationSelected = 'Location Selected',
  CategorySelected = 'Category Selected',
  ServiceSelected = 'Service Selected',
  ClassSelected = 'Class Selected',
  DateSelected = 'Date Selected',
  AppointmentSelected = 'Appointment Selected',
  BookingMade = 'Booking Made',
  AppointmentTimeBackButton = 'Appointment Time Back Button',
  ChangeDate = 'AppointmentSelectScreenChangeDate',
  Previous = 'AppointmentSelectScreenPrevious',
  Next = 'AppointmentSelectScreenNext',
  NextAvailable = 'AppointmentSelectNextAvailable',
  AppointmentBooked = 'AppointmentBooked',
  Purchase = 'Purchase',
  DisconnectSSO = 'Disconnect SSO',
  GuidedSelectorViewed = 'Guided Selector Viewed',
  GuidedSelectorOptionSelected = 'Guided Selector Option Selected',
  GuidedSelectorFundingSelected = 'Guided Selector Funding Selected',
  GuidedSelectorHandoff = 'Guided Selector Handoff',
  GuidedSelectorAppointmentlessCreated = 'Guided Selector Appointmentless Created',
  GuidedSelectorCannotBookOnline = 'Guided Selector Cannot Book Online',
  BookingRequirementsModalSubmit = 'Booking Requirements Modal Submit',
  BookingRequirementsModalClose = 'Booking Requirements Modal Close'
}
// future proofing for if we add our own analytics events
export const analyticsEventMapping: Record<AnalyticsEvents, { ga: string; analytics: string }> = {
  [AnalyticsEvents.ConnectVisit]: { ga: '', analytics: 'Connect Visit' },
  [AnalyticsEvents.ConnectSignUp]: { ga: 'sign_up', analytics: 'Connect Sign Up' },
  [AnalyticsEvents.SignUpFail]: { ga: 'sign_up_failed', analytics: 'Sign Up Fail' },
  [AnalyticsEvents.Login]: { ga: 'login', analytics: 'Login' },
  [AnalyticsEvents.LoginSSO]: { ga: 'login_sso', june: 'Login SSO' },
  [AnalyticsEvents.DisconnectSSO]: { ga: 'disconnect_sso', june: 'Disconnect SSO' },
  [AnalyticsEvents.LocationSelected]: { ga: 'location_selected', analytics: 'Location Selected' },
  [AnalyticsEvents.CategorySelected]: { ga: 'category_selected', analytics: 'Category Selected' },
  [AnalyticsEvents.ServiceSelected]: { ga: 'service_selected', analytics: 'Service Selected' },
  [AnalyticsEvents.ClassSelected]: { ga: 'class_selected', analytics: 'Class Selected' },
  [AnalyticsEvents.DateSelected]: { ga: 'date_selected', analytics: 'Date Selected' },
  [AnalyticsEvents.AppointmentSelected]: {
    ga: 'appointment_selected',
    analytics: 'Appointment Selected'
  },
  [AnalyticsEvents.BookingMade]: { ga: 'booking_made', analytics: 'Booking Made' },
  [AnalyticsEvents.AppointmentTimeBackButton]: { ga: 'Appointment_Time_BackButton', analytics: '' },
  [AnalyticsEvents.ChangeDate]: { ga: 'AppointmentSelectScreenChangeDate', analytics: '' },
  [AnalyticsEvents.Previous]: { ga: 'AppointmentSelectScreenPrevious', analytics: '' },
  [AnalyticsEvents.Next]: { ga: 'AppointmentSelectScreenNext', analytics: '' },
  [AnalyticsEvents.NextAvailable]: { ga: 'AppointmentSelectNextAvailable', analytics: '' },
  [AnalyticsEvents.AppointmentBooked]: {
    ga: 'appointment_booked',
    analytics: 'Appointment Booked'
  },
  [AnalyticsEvents.Purchase]: { ga: 'purchase', analytics: 'Purchase' },
  [AnalyticsEvents.GuidedSelectorViewed]: {
    ga: 'guided_selector_viewed',
    analytics: 'Guided Selector Viewed'
  },
  [AnalyticsEvents.GuidedSelectorOptionSelected]: {
    ga: 'guided_selector_option_selected',
    analytics: 'Guided Selector Option Selected'
  },
  [AnalyticsEvents.GuidedSelectorFundingSelected]: {
    ga: 'guided_selector_funding_selected',
    analytics: 'Guided Selector Funding Selected'
  },
  [AnalyticsEvents.GuidedSelectorHandoff]: {
    ga: 'guided_selector_handoff',
    analytics: 'Guided Selector Handoff'
  },
  [AnalyticsEvents.GuidedSelectorAppointmentlessCreated]: {
    ga: 'guided_selector_appointmentless_created',
    analytics: 'Guided Selector Appointmentless Created'
  },
  [AnalyticsEvents.GuidedSelectorCannotBookOnline]: {
    ga: 'guided_selector_cannot_book_online',
    analytics: 'Guided Selector Cannot Book Online'
  },
  [AnalyticsEvents.BookingRequirementsModalSubmit]: {
    ga: 'booking_requirements_modal_submit',
    analytics: 'Booking Requirements Modal Submit'
  },
  [AnalyticsEvents.BookingRequirementsModalClose]: {
    ga: 'booking_requirements_modal_close',
    analytics: 'Booking Requirements Modal Close'
  }
};
